export default __webpack_public_path__ + "static/media/style2.48f351c1.svg";